const steps = [
  {
    no: '01',
    title: '爆料出现',
    text: '一句没有来源的描述、一张看不清出处的截图，往往就是整个事件的起点。',
    icon: 'ri-chat-new-line',
  },
  {
    no: '02',
    title: '情绪放大',
    text: '搬运账号不断补上结论性描述，版本越传越多，细节越来越少。',
    icon: 'ri-megaphone-line',
  },
  {
    no: '03',
    title: '材料核实',
    text: '通告单、完整流水、鉴定摘要、官方通报陆续出现，事实开始对得上号。',
    icon: 'ri-search-eye-line',
  },
  {
    no: '04',
    title: '走向落定',
    text: '剧情反转或是误会澄清，我们把最终走向标注清楚并持续跟进。',
    icon: 'ri-checkbox-circle-line',
  },
];

export default function ProcessSection() {
  return (
    <section aria-labelledby="process-heading" className="mx-auto w-full px-4 py-14 md:px-6 md:py-20">
      <div className="reveal mb-10 text-center">
        <span className="text-xs font-semibold font-label uppercase tracking-widest text-secondary-600">
          How It Unfolds
        </span>
        <h2 id="process-heading" className="mt-2 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
          一条爆料通常会经历什么
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
          看懂这四个阶段，你就能判断自己此刻看到的，到底是事实，还是还没被核实过的描述。
        </p>
      </div>

      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
        {steps.map((step, index) => (
          <div
            key={step.no}
            className="reveal relative rounded-lg border border-background-300 bg-background-50 p-5 md:p-6"
          >
            <span className="font-heading text-3xl font-bold text-background-400">{step.no}</span>
            <span className="absolute right-5 top-5 flex h-10 w-10 items-center justify-center rounded-full bg-accent-100 text-accent-800">
              <i className={`${step.icon} text-lg`} aria-hidden="true" />
            </span>
            <h3 className="mt-3 font-heading text-lg font-bold text-foreground-950">{step.title}</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">{step.text}</p>
            {index < steps.length - 1 ? (
              <span className="absolute -right-3 top-1/2 hidden h-6 w-6 -translate-y-1/2 items-center justify-center rounded-full border border-background-300 bg-background-50 text-foreground-400 lg:flex">
                <i className="ri-arrow-right-s-line" aria-hidden="true" />
              </span>
            ) : null}
          </div>
        ))}
      </div>
    </section>
  );
}